import { Col,Card,CardBody, Row, Breadcrumb, Container } from "reactstrap"
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader"
import Breadcrumbs from "../../../../coreComponents/breadcrumbs"
import { usersTitle,updateUserProfile } from "../../../../constants"
import EditUserProfile from "../EditUserProfile"
import SignUpForm from "../../../registerForm/RegisterForm"
import { useParams } from "react-router-dom"
import UpdateUser from "../UpdateUser"
import UpdatePassword from "../UpdatePassword"
import { useAppSelector } from "../../../../reduxToolkit/hooks"
import {Button , Modal ,ModalBody,ModalHeader,ModalFooter} from  'reactstrap'
import { useNavigate } from "react-router-dom"
import{toast} from 'react-toastify'
import ApiService from "../../../../services/apiService"
import { useState } from "react"

const UserProfile = () =>{
    const role = useAppSelector((state: any)=> state.role.role);
    const {Id} = useParams();
    const navigate = useNavigate();
    const [isDeleteModalOpen,setIsDeleteModalOpen ] = useState(false)
    const [selectedId , setSelectedId] = useState("")


  const handleDeleteUser = async (selectedId: string) => {
    try {
       
          const response = await ApiService.axiosApi(`/auth/${selectedId}`,{
            method : 'DELETE',
          });

          if(response.success){
            
            toast.success(response.data.UserName);
            setIsDeleteModalOpen(false);
            navigate(-1)
            
          }
          else {
            toast.error(response.message);
          }
    } catch (error: any) {
        toast.error(error.message);
    }
  }
  const handleDelete = (id: any) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
}

    return(

      <>
      <Breadcrumbs mainTitle={updateUserProfile} parent={usersTitle} />
    
      {role === "Administrator" && (
        <div className="d-flex justify-content-end mb-1">
          <Button onClick={() => handleDelete(Id)} color="danger">Delete User</Button>
        </div>
      )}
    
      <div className="edit-profiles container-fluid" style={{ padding: '1rem' }}>
        {/* Row with EditUserProfile and UpdateUser side by side */}
        <div className="d-flex" style={{ gap: '15px', width: '100%' }}>
          <div style={{ flex: 1 }}>
            <EditUserProfile userId={Id} />
          </div>
          <div style={{ flex: 1 }}>
            <UpdateUser />
          </div>
        </div>
    
        {/* Full width block below */}
        <div className="pt-3">
          <UpdatePassword />
        </div>
      </div>
    
      <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>
        <ModalHeader>Delete User</ModalHeader>
        <ModalBody>Are you sure you want to delete this user?</ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={() => handleDeleteUser(selectedId)}>Delete</Button>
          <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
    

    )
}

export default UserProfile;